import React from "react";
import { useTranslation } from "react-i18next";
import { FaPenNib } from "react-icons/fa";

const Blog = () => {
  const { t } = useTranslation();

  return (
    <section className="flex justify-center">
      <div className="w-full max-w-2xl">
        <div className="border border-border rounded p-12 text-center">
          <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded border border-cyan text-cyan">
            <FaPenNib className="text-2xl" />
          </div>
          <h2 className="text-2xl text-text font-semibold mb-4">{t("blog.title")}</h2>
          <p className="text-[1.0625rem] leading-[1.7] text-prose mb-6 md:text-lg md:leading-[1.75]">{t("blog.description")}</p>
          <p className="font-mono text-xs text-muted">{t("blog.stayTuned")}</p>
        </div>
      </div>
    </section>
  );
};

export default Blog;
